import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import { token } from '@atlaskit/tokens';

import { DAC_DOCS_BASE_URL } from '@/constants';
import { flexCenter, tooltipStyls } from '@/styles';

export const helperCopy: { [key: string]: any } = {
  refiner: {
    sloGroup: (
      <Tooltip
        content={
          <span css={tooltipStyls}>
            An SLO Group is a structured collection of related SLOs organized hierarchically,
            designed for tracking across geos/regions/shards.
            <br />
            <br />
            <a target="_blank" rel="noopener noreferrer" href={`${DAC_DOCS_BASE_URL}slo-groups/`}>
              Find out more
            </a>
          </span>
        }
        position="right"
      >
        <div css={flexCenter}>
          <QuestionCircleIcon
            primaryColor={token('color.icon')}
            label="question-icon"
            size="small"
          />
        </div>
      </Tooltip>
    ),
  },
};
